export default __webpack_public_path__ + "static/media/Front-Villa-Ahmad-Helbawi.314c9230.jpg";